import useLenis from "../hooks/useLenis";
import { Toaster } from "sonner";
import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { Services } from "../components/site/Services";
import { Manifesto } from "../components/site/Manifesto";
import { Marquee } from "../components/site/Marquee";
import { Outcomes } from "../components/site/Outcomes";
import { FAQ } from "../components/site/FAQ";
import { Contact } from "../components/site/Contact";
import { Footer } from "../components/site/Footer";
import { WhatsAppButton } from "../components/site/WhatsAppButton";

export default function Home() {
  useLenis();

  return (
    <div className="bg-brand-bg text-brand-ink min-h-screen overflow-x-hidden">
      <Toaster position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Manifesto />
        <Outcomes />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
